import { Divider, Grid, Typography } from '@mui/material';
import React from 'react';

interface IInterviewModalHeader {
  reqId: string;
  title: string;
  subTitle: string;
}

const InterviewModalHeader = ({
  reqId,
  title,
  subTitle,
}: IInterviewModalHeader) => {
  return (
    <Grid container data-testid='interview-modal-header-container'>
      <Grid item xs={12}>
        <Typography
          id='interview-modal-header-title'
          data-testid='interview-modal-header-title'
          className='kfic2-headerBold'
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          id='interview-modal-header-subtitle'
          data-testid='interview-modal-header-subtitle'
          className='kfic2-bodyTextSmall'
        >
          {`${subTitle} (${reqId})`}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider
          id='interview-modal-header-divider'
          data-testid='interview-modal-header-divider'
          sx={{
            mt: ({ typography }) => typography.pxToRem(8),
            mb: ({ typography }) => typography.pxToRem(0),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default InterviewModalHeader;
